enum ScheduleType {
  SCHEDULED,
  ROUND,
  INSTANT,
  MULTIPLE,
}

export default ScheduleType;